document.addEventListener('DOMContentLoaded', function () {
  var sliderSelector = '.related_products--slider__enable';
  var hasInitialized = false;

  function initializeSlider() {
    var $slider = $(sliderSelector);
    var itemCount = $slider.find('li').length;

    if (itemCount > 4) {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      $slider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        swipe: true,
        nextArrow:
      '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="17" viewBox="0 0 8 17" fill="currentColor"><path d="M0.0393023 16.2594C0.182777 16.7018 0.547987 17 0.939283 17C1.35667 17 1.36536 16.9901 4.61746 13.2621C7.39566 10.0808 7.67827 9.73786 7.80435 9.43962C8.06522 8.8332 8.06522 8.16713 7.80435 7.56071C7.67827 7.26247 7.39566 6.91949 4.61746 3.73827C1.27406 -0.0990846 1.33493 -0.0344636 0.878414 0.0102714C0.365381 0.0599788 0.00451969 0.497397 0.00451972 1.06902C0.00886753 1.25791 0.0393017 1.43188 0.0871265 1.54124C0.130604 1.63568 1.50014 3.2412 3.12619 5.1052L6.09135 8.50016L3.12619 11.8902C1.50014 13.7591 0.130605 15.3597 0.0914749 15.4492C-0.00417524 15.6778 -0.0302611 16.0456 0.0393023 16.2594Z" fill="currentColor"></path></svg></button>',
  prevArrow:
      '<button class="slick-prev slick-arrow"><svg width="8" height="17" viewBox="0 0 8 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M7.9607 0.740629C7.81722 0.29824 7.45201 3.25738e-07 7.06072 3.08634e-07C6.64333 2.90389e-07 6.63464 0.00994163 3.38254 3.73794C0.604335 6.91916 0.321732 7.26214 0.195648 7.56038C-0.0652163 8.1668 -0.0652164 8.83287 0.195648 9.43929C0.321732 9.73753 0.604334 10.0805 3.38254 13.2617C6.72594 17.0991 6.66507 17.0345 7.12158 16.9897C7.63462 16.94 7.99548 16.5026 7.99548 15.931C7.99113 15.7421 7.9607 15.5681 7.91287 15.4588C7.86939 15.3643 6.49986 13.7588 4.87381 11.8948L1.90865 8.49984L4.87381 5.10984C6.49986 3.24087 7.8694 1.64032 7.90852 1.55085C8.00418 1.3222 8.03026 0.954368 7.9607 0.740629Z" fill="currentColor"/></svg></button>',

        responsive: [
          { breakpoint: 992, settings: { slidesToShow: 3 } },
          { breakpoint: 768, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1 } }
        ]
      });

      hasInitialized = true;
    }
  }

  function observeAndInitSlider() {
    var section = document.querySelector('product-recommendations');
    if (!section) return;

    var io = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !hasInitialized) {
          setTimeout(initializeSlider, 1000);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    io.observe(section);
  }

  // 1️⃣ Initial load + AJAX dynamic load
  var mo = new MutationObserver(function (mutations, observer) {
    var section = document.querySelector('product-recommendations');
    if (section) {
      observeAndInitSlider();
      observer.disconnect();
    }
  });

  mo.observe(document.body, { childList: true, subtree: true });

  // 2️⃣ Also handle customizer events
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('product-recommendations');
    if (section) {
      hasInitialized = false; // allow re-initialization
      observeAndInitSlider();
    }
  });

  // Optional: Handle section reorder, remove, etc. (for good measure)
  document.addEventListener('shopify:section:reorder', function () {
    hasInitialized = false;
  });

  document.addEventListener('shopify:section:unload', function () {
    if ($(sliderSelector).hasClass('slick-initialized')) {
      $(sliderSelector).slick('unslick');
    }
    hasInitialized = false;
  });
});
